module.exports = __webpack_public_path__ + "img/docx.f6984c55.png";